import packageJson from '../package.json';

const config = {
  version: packageJson.version,
  autenticar: {
    url: import.meta.env.VITE_AUTENTICAR_URL,
    key: import.meta.env.VITE_AUTENTICAR_KEY,
  },
  api: {
    url: import.meta.env.VITE_API_URL,
  },
  target: {
    url: import.meta.env.VITE_URL,
  },
};

export default config;
